import { createFragmentContainer, graphql } from "react-relay";
import { useState, useCallback } from "react";
import JobEvent from "~/components/JobActivityTimeline/JobEvent";

interface StackErrorEvent {
  uuid: string;
  timestamp: string;
  detail: string;
}

type Props = {
  event: StackErrorEvent;
  previousTimestamp: string | null | undefined;
};

const MAX_TRUNCATED_LENGTH = 500;

function JobEventStackFinished({ event, previousTimestamp }: Props) {
  const detail = event.detail || "";
  const shouldTruncate = detail.length > MAX_TRUNCATED_LENGTH;
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>Stack attempted to end the Job with success exit status</JobEvent.Label>
      <JobEvent.Content>
        <div className="bg-silver border-gray m-0 whitespace-pre-wrap rounded-sm border px-2 py-1 text-sm font-normal">
          <span id={`error-detail-${event.uuid}`}>
            {isExpanded ? detail : detail.slice(0, MAX_TRUNCATED_LENGTH)}
          </span>
          {shouldTruncate && !isExpanded && <span>...</span>}
          {shouldTruncate && (
            <button
              type="button"
              onClick={toggleExpanded}
              className="ml-2 font-medium"
              aria-expanded={isExpanded}
              aria-controls={`detail-${event.uuid}`}
              aria-label={isExpanded ? "Show full details" : "Show less detail"}
            >
              {isExpanded ? "Show less" : "Show more"}
            </button>
          )}
        </div>
      </JobEvent.Content>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventStackFinished, {
  event: graphql`
    fragment JobEventStackFinished_event on JobEvent {
      ... on JobEvent {
        uuid
        timestamp
        ... on JobEventStackFinished {
          detail
        }
      }
    }
  `,
});
